import { css } from "@emotion/react";
import { memo } from "react";
import { HashLink } from "react-router-hash-link";

const About = () => {
  const scrollWithOffset = (el: HTMLElement, offset: number) => {
    const elementPosition = el.offsetTop - offset;
    window.scroll({
      top: elementPosition,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <div
        css={css`
          padding: 100px;
          max-width: 860px;
          margin: 0 auto;
          background-color: rgba(230, 60, 60, 0.9);
          color: #fff;
          @media screen and (max-width: 1024px) {
            padding: 24px;
          }
        `}
      >
        <h2>
          YAKO is a project that brings 36 Japanese artists together to share a
          new Japanese culture of Reiwa with the world.
        </h2>
        <p
          css={css`
            padding-top: 20px;
          `}
        >
          (Reiwa is the name of the new Japanese imperial era and represents
          auspicious harmony.) through the co-creation of a collectible NFT with
          36 amazing Japanese artists and the theme of the art is "Night Parade
          of One Hundred Demons".
        </p>
        <p
          css={css`
            padding-top: 16px;
          `}
        >
          Our 36 artists are working on 10 different visual patterns for 12
          different Yokai (Tengu, Kappa...etc) that come from Japanese folk
          stories. And we’re going to put the 10 visual patterns into a picture
          scroll that we call “Emaki” and make 3,600 of it. Each one of the
          Emaki is unique. A variety of visual effects will be applied to the
          picture scrolls to create a new collectible NFT that no one has yet
          seen, merging the good old Japanese style with the latest modern
          technology. You can call it “YAKO”.
        </p>
        <p
          css={css`
            padding-top: 16px;
            text-align: right;

            & > a {
              color: #fff;
            }
          `}
        >
          <HashLink
            smooth
            to={`/#yokai`}
            scroll={(el) => scrollWithOffset(el, 150)}
          >
            <span>Want to know what Yokai is?</span>
          </HashLink>
        </p>
      </div>
      <div
        id="about"
        css={css`
          position: relative;
          max-width: 860px;
          margin: 0 auto;
          background-color: rgba(230, 60, 60, 0.9);

          &:before {
            content: "";
            display: block;
            width: 100%;
            padding-top: 100%;
          }

          &:after {
            /* content: "Coming soon"; */
            color: rgba(255, 255, 255, 0.3);
            display: flex;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 22px;
          }

          & img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 1px solid #000;
            object-fit: cover;
          }
        `}
      >
        <img src="/img/makimono.gif" alt="" />
      </div>
    </>
  );
};
export default memo(About);
